import { TENANCY } from 'config/tenancy';
import { IFacialRecognitionsRepository } from 'shared/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import { VectisFacialRecognitionsRepository } from './implementations/VectisFacialRecognitionsRepository';

let instance: IFacialRecognitionsRepository | null = null;

export default function makeFacialRecognitionsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider({ language: TENANCY });

    instance = new VectisFacialRecognitionsRepository(httpProvider);
  }

  return instance;
}
